/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';
import activityTextClass from 'constants/ActivityTheme';

const ActivityCardBg = styled.div`
  background-image: url(${({ image }) => image.url});
`;
const Overlay = styled.div.attrs(() => {
  const classNamesToAdd = [
    'flex',
    'items-end',
    'w-full',
    'h-full',
    'rounded-base',
    // Set the gradient
    'relative',
    'bg-gradient-to-b',
    'from-transparent',
    'to-hoverShade',
    'z-10',
    // Set the opposite gradient for the ::before
    'before:rounded-base',
    'before:bg-gradient-to-b',
    'before:from-hoverShade',
    'before:to-transparent',
    'before:inset-0',
    'before:transition-opacity',
    'before:opacity-0',
    'before:duration-200',
    'before:empty-content',
    'before:-z-10',
    'before:absolute',
    // On hover make the ::before opacity with transition
    'beforeHover:opacity-100',
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

const LabelWrap = styled.div.attrs(({ themeIcon }) => {
  const classNamesToAdd = [
    'h-11',
    'w-11',
    'md:h-13',
    'md:w-13',
    'mr-4',
    'bg-white',
    'rounded-lg',
    'flex',
    'flex-col',
    'justify-center',
    'items-center',
    activityTextClass[themeIcon],
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;
export { ActivityCardBg, LabelWrap, Overlay };
